import React from 'react';
import { getSortIndicator } from '../../utils/tableSortUtils';

const SORTABLE_STYLE = { cursor: 'pointer', userSelect: 'none' };

/**
 * Clickable table header with asc/desc indicator.
 * Pass sortable={false} for action/checkbox columns.
 */
export default function SortableTableHeader({
    field,
    sortField,
    sortDirection,
    onSort,
    children,
    style,
    className,
    sortable = true,
    ...rest
}) {
    if (!sortable || !onSort || !field) {
        return (
            <th className={className} style={style} {...rest}>
                {children}
            </th>
        );
    }

    return (
        <th
            className={className ? `${className} sortable-table-header` : 'sortable-table-header'}
            style={{ ...SORTABLE_STYLE, ...style }}
            onClick={() => onSort(field)}
            {...rest}
        >
            {children}
            {getSortIndicator(sortField, field, sortDirection)}
        </th>
    );
}
